module.exports = __webpack_public_path__ + "img/GENERAL-JIMNY-3.24e86a75.jpg";